import { setToast } from '@/entities/toast'
import { OLMSApiService } from '@/shared/apis'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { Group } from '../models/Group'

type SaveGroupPayload = {
  group: Record<string, unknown>
}

export const saveGroup = createAsyncThunk<Group, SaveGroupPayload, ThunkApiContext>('groups/saveGroup', async ({ group }, { dispatch }) => {
  const response = await OLMSApiService.post<Group>('group/save', group)

  if (!response) {
    dispatch(setToast({
      open: true,
      severity: 'error',
      title: 'Save group',
      content: 'Failed to save group',
    }))
    throw new Error('Failed to save group')
  }

  dispatch(setToast({
    open: true,
    severity: 'success',
    title: 'Save group',
    content: `Successfully saved group ${response.name}`,
  }))

  return response
})